<template>
  <div class="login-section">
    <div class="login-form__title">
      Reset Password
    </div>
    <div class="reset-password__container">
      <template v-if="submitMessage">
        {{ submitMessage }}
      </template>
      <template v-else>
        We will send you an email including instructions to reset your password.
      </template>
    </div>
    <div class="reset-password__container">
      <div class="login-form__item">
        <input
          id="subdomain"
          v-model="subDomain"
          aria-label="Subdomain field"
          type="text"
          class="login-form__field"
          placeholder="Subdomain"
          :disabled="resetRequestSuccess"
        />
      </div>
      <input
        id="username"
        v-model="username"
        aria-label="Username field"
        type="text"
        class="login-form__field"
        placeholder="Username"
        :disabled="resetRequestSuccess"
      />
    </div>
    <div class="reset-password__container reset-password__container--icon">
      <transition
        name="fade"
        mode="out-in"
      >
        <template v-if="resetRequestSuccess">
          <img
            class="reset-password__icon"
            src="../../assets/success-dark.svg"
          />
        </template>
        <template v-else>
          <button
            id="reset-password"
            class="btn btn-primary--green"
            @click="requestReset"
          >
            Reset Password
          </button>
        </template>
      </transition>
    </div>
    <div class="reset-password__footer">
      <span
        id="return-login"
        class="login__link"
        @click="toLoginScreen"
      > Back to Sign In </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  data() {
    return {
      username: '',
      subDomain: '',
      resetRequestSuccess: false,
      submitMessage: '',
    }
  },
  methods: {
    toLoginScreen() {
      this.$emit('navigate-login')
    },
    requestReset() {
      this.submitMessage = ''
      if (this.username && this.subDomain) {
        this.$emit('request-reset', {
          username: this.username,
          subDomain: this.subDomain,
        })
        this.resetRequestSuccess = true
        this.submitMessage = 'Further instructions will be sent to your email.'
      } else {
        this.submitMessage = 'Please fill in both fields.'
      }
    },
  },
}
</script>
